import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { S as STARS_COUNT } from './const.js';

const mapyReviewStarsCss = ":host {\n\tdisplay: inline-block;\n\tpadding: 0;\n}\n\n.wrapper {\n\t--stars: 5;\n\t--starsize: 30px;\n\t--gap: 0px;\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgrid-template-rows: 1fr;\n\tgrid-column-gap: var(--gap);\n\tgrid-row-gap: 0px;\n\tcursor: pointer;\n\tuser-select: none;\n\toutline: none;\n\t-webkit-tap-highlight-color: transparent;\n}\n\ninput {\n\ttouch-action: manipulation;\n\tappearance: none;\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\topacity: 0;\n\tgrid-area: 1 / 1 / 2 / 6;\n\tcursor: pointer;\n}\n\ninput::-moz-range-track {\n\theight: 100%;\n\topacity: 0;\n}\n\ninput::-webkit-slider-runnable-track {\n\theight: 100%;\n\topacity: 0;\n}\n\ninput::-moz-range-thumb {\n\topacity: 0;\n\tappearance: none;\n\tdisplay: block;\n\twidth: 1px;\n\theight: 100%;\n}\n\ninput::-webkit-slider-thumb {\n\topacity: 0;\n\tappearance: none;\n\tdisplay: block;\n\twidth: 1px;\n\theight: 100%;\n}\n\n.wrapper[data-disabled] {\n\tcursor: default;\n\n\tinput {\n\t\tcursor: default;\n\t}\n}\n\n.star {\n\twidth: var(--starsize);\n\theight: var(--starsize);\n}\n\n.star1 {\n\tgrid-area: 1 / 1 / 2 / 2;\n}\n\n.star2 {\n\tgrid-area: 1 / 2 / 2 / 3;\n}\n\n.star3 {\n\tgrid-area: 1 / 3 / 2 / 4;\n}\n\n.star4 {\n\tgrid-area: 1 / 4 / 2 / 5;\n}\n\n.star5 {\n\tgrid-area: 1 / 5 / 2 / 6;\n}\n\n.background.outline .left,\n.background.outline .right {\n\tdisplay: none;\n}\n\n.background.outline .outline {\n\tstroke: #f6a622;\n}\n\n.background.fill .left,\n.background.fill .right {\n\tfill: #ccc;\n}\n\n.background.fill .outline {\n\tstroke: #ccc;\n}\n\n.value.fill .left,\n.value.fill .right {\n\tfill: #f6a622;\n}\n\n.value.fill .outline {\n\tstroke: #f6a622;\n}\n\n.value.half {\n\t-webkit-mask-image: linear-gradient(90deg, #ffffff 0%, #ffffff 50%, #000000 50%, #000000 100%);\n\tmask-image: linear-gradient(90deg, #ffffff 0%, #ffffff 50%, #000000 50%, #000000 100%);\n\t-webkit-mask-size: calc(var(--starsize) / 2);\n\tmask-size: calc(var(--starsize) / 2);\n\t-webkit-mask-repeat: no-repeat;\n\tmask-repeat: no-repeat;\n\t-webkit-mask-position: left;\n\tmask-position: left;\n}\n\n.overlay {\n\topacity: 0;\n\tgrid-area: 1 / 1 / 2 / 6;\n}\n";
const MapyReviewStarsStyle0 = mapyReviewStarsCss;

var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _MapyReviewStars_wrapperEl;
const Star = (_a) => {
    var args = __rest(_a, []);
    return h("svg", Object.assign({ viewBox: "0 0 30 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, args), h("path", { d: "M7.20911 27.7067L14.7394 23.1072C14.8194 23.0583 14.9097 23.0339 15 23.0339V2C14.8119 1.99999 14.6237 2.10265 14.5383 2.30798L11.1497 10.4552C11.0777 10.6283 10.9149 10.7466 10.728 10.7616L1.93243 11.4667C1.4891 11.5022 1.30934 12.0555 1.64711 12.3448L8.34841 18.0852C8.4908 18.2072 8.55299 18.3986 8.50949 18.5809L6.46213 27.1639C6.35894 27.5965 6.82956 27.9385 7.20911 27.7067Z", class: "left" }), h("path", { d: "M22.7909 27.7067L15.2606 23.1072C15.1806 23.0583 15.0903 23.0339 15 23.0339V2C15.1881 1.99999 15.3763 2.10265 15.4617 2.30798L18.8503 10.4552C18.9223 10.6283 19.0851 10.7466 19.272 10.7616L28.0676 11.4667C28.5109 11.5022 28.6907 12.0555 28.3529 12.3448L21.6516 18.0852C21.5092 18.2072 21.447 18.3986 21.4905 18.5809L23.5379 27.1639C23.6411 27.5965 23.1704 27.9385 22.7909 27.7067Z", class: "right" }), h("path", { d: "M14.5383 2.10996C14.7091 1.69932 15.2909 1.69932 15.4617 2.10996L18.8503 10.2572C18.9223 10.4303 19.0851 10.5486 19.272 10.5635L28.0675 11.2687C28.5109 11.3042 28.6906 11.8575 28.3529 12.1468L21.6516 17.8872C21.5092 18.0092 21.447 18.2006 21.4905 18.3829L23.5379 26.9659C23.641 27.3985 23.1704 27.7405 22.7909 27.5086L15.2606 22.9092C15.1006 22.8115 14.8994 22.8115 14.7394 22.9092L7.20913 27.5086C6.82958 27.7405 6.35896 27.3985 6.46215 26.9659L8.50951 18.3829C8.55301 18.2006 8.49083 18.0092 8.34843 17.8872L1.64713 12.1468C1.30936 11.8575 1.48912 11.3042 1.93245 11.2687L10.728 10.5635C10.9149 10.5486 11.0777 10.4303 11.1497 10.2572L14.5383 2.10996Z", class: "outline" }));
};
const MapyReviewStars = /*@__PURE__*/ proxyCustomElement(class MapyReviewStars extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.input = createEvent(this, "input", 2);
        _MapyReviewStars_wrapperEl.set(this, void 0);
        this.handleInput = (event) => {
            event.stopPropagation();
            event.preventDefault();
            const input = event.target;
            if (input && !this.disabled) {
                const stars = this.positionToStars(parseFloat(input.value));
                this.value = stars;
                this.displayValue = this.value;
                this.input.emit(this.value);
            }
        };
        this.handleClick = (event) => {
            if (!this.disabled) {
                this.value = this.getValue(__classPrivateFieldGet(this, _MapyReviewStars_wrapperEl, "f").getBoundingClientRect(), event);
                this.displayValue = this.value;
            }
        };
        this.handlePointerEnter = (event) => {
            if (!this.disabled && event.pointerType !== "touch") {
                this.displayValue = this.getValue(__classPrivateFieldGet(this, _MapyReviewStars_wrapperEl, "f").getBoundingClientRect(), event);
            }
        };
        this.handlePointerMove = (event) => {
            if (!this.disabled && event.pointerType !== "touch") {
                this.displayValue = this.getValue(__classPrivateFieldGet(this, _MapyReviewStars_wrapperEl, "f").getBoundingClientRect(), event);
            }
        };
        this.handlePointerLeave = (event) => {
            if (!this.disabled && event.pointerType !== "touch") {
                this.displayValue = this.value;
            }
        };
        this.onKeyDown = (event) => {
            let direction = 0;
            if (event.code === "ArrowLeft" || event.code === "ArrowDown") {
                direction = -0.5;
            }
            else if (event.code === "ArrowRight" || event.code === "ArrowUp") {
                direction = 0.5;
            }
            if (direction !== 0) {
                event.stopPropagation();
                event.preventDefault();
                const newStarsValue = Math.min(STARS_COUNT, Math.max(1, this.value + direction));
                if (this.value !== newStarsValue) {
                    this.value = newStarsValue;
                    this.displayValue = this.value;
                    this.input.emit(this.value);
                }
            }
        };
        this.disabled = false;
        this.size = 30;
        this.value = 0;
        this.gap = 0;
        this.displayValue = 0;
    }
    onValueChange(newValue) {
        this.displayValue = newValue;
    }
    positionToStars(position) {
        const { gap, size } = this;
        const halfStar = size / 2 >>> 0;
        let posX = size + gap;
        let value = 1;
        let findValue = 1;
        for (let ind = 1; ind <= 4; ind++) {
            if (position >= posX && position <= posX + halfStar) {
                findValue = value + 0.5;
                break;
            }
            else if (position >= posX + halfStar && position <= posX + size + gap) {
                findValue = value + 1;
                break;
            }
            value += 1;
            posX += size + gap;
        }
        return findValue;
    }
    getValue(rect, event) {
        const coorX = event.clientX - rect.left;
        return this.positionToStars(coorX);
    }
    componentWillLoad() {
        this.displayValue = this.value;
    }
    render() {
        const { disabled, size, displayValue, gap, } = this;
        const width = (5 * size) + (4 * gap);
        return (h(Host, { key: 'cfaff17857484ed783224d70a59ec692d270a8ff', "aria-disabled": disabled ? "true" : null }, h("div", { key: '274e6b3d7587a81bd75ebef0a5be691052cbfe86', class: "wrapper", style: { "--starsize": `${size}px`, "--gap": `${gap}px`, "width": `${width}px` }, onClick: this.handleClick, onPointerEnter: this.handlePointerEnter, onPointerMove: this.handlePointerMove, onPointerLeave: this.handlePointerLeave, ref: wrapperEl => { __classPrivateFieldSet(this, _MapyReviewStars_wrapperEl, wrapperEl, "f"); }, "data-disabled": disabled }, h(Star, { key: '37ae3dd93a21b9a4970e2d0ea50c97664cdd6af3', class: `${disabled ? "fill" : "outline"} star star1 background` }), h(Star, { key: '20096978e6e49127b50249710f6e1b4036cae090', class: `${disabled ? "fill" : "outline"} star star2 background` }), h(Star, { key: '39dff4e001a4af431b61b35213925d62935570e9', class: `${disabled ? "fill" : "outline"} star star3 background` }), h(Star, { key: 'c6a240abe21fac8f1c6ac0efec19f5b393380994', class: `${disabled ? "fill" : "outline"} star star4 background` }), h(Star, { key: '7e1849f1b6d244e1b1b7d4993967af1d5ee0da54', class: `${disabled ? "fill" : "outline"} star star5 background` }), displayValue >= 0.5 ? h(Star, { class: `fill star star1 value ${displayValue === 0.5 ? "half" : ""}` }) : null, displayValue >= 1.5 ? h(Star, { class: `fill star star2 value ${displayValue === 1.5 ? "half" : ""}` }) : null, displayValue >= 2.5 ? h(Star, { class: `fill star star3 value ${displayValue === 2.5 ? "half" : ""}` }) : null, displayValue >= 3.5 ? h(Star, { class: `fill star star4 value ${displayValue === 3.5 ? "half" : ""}` }) : null, displayValue >= 4.5 ? h(Star, { class: `fill star star5 value ${displayValue === 4.5 ? "half" : ""}` }) : null, h("input", { key: '208db50523d3ca412ebca7c4cd242379825cccf9', disabled: disabled, max: width, min: "0", onInput: this.handleInput, type: "range", value: displayValue, onClick: this.handleClick, onKeyDown: this.onKeyDown, onPointerEnter: this.handlePointerEnter, onPointerMove: this.handlePointerMove, onPointerLeave: this.handlePointerLeave }))));
    }
    static get watchers() { return {
        "value": ["onValueChange"]
    }; }
    static get style() { return MapyReviewStarsStyle0; }
}, [1, "mapy-review-stars", {
        "disabled": [516],
        "size": [514],
        "value": [514],
        "gap": [514],
        "displayValue": [32]
    }, undefined, {
        "value": ["onValueChange"]
    }]);
_MapyReviewStars_wrapperEl = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-stars"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-stars":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewStars);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewStars as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-stars2.js.map